(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vMapboxgl", [], factory);
	else if(typeof exports === 'object')
		exports["vMapboxgl"] = factory();
	else
		root["vMapboxgl"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition